import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles<boolean>()((theme, isMobile) => ({
    cardContent: {
        display: "flex",
        backgroundColor: theme.palette.background.dark,
        alignItems: "center",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
    },
    leftBox: {
        display: "flex",
        alignItems: isMobile ? "flex-start" : "center",
        flexDirection: "row",
        gap: theme.spacing(2),
    },
    link: {
        cursor: "pointer",
    },
}));
